import React from 'react';

var CloneSuccessPopup = React.createClass({
	handleCloseClick: function(){
		this.props.cloneSuccess("close");
	},
	stopPropogation: function(e){
		e.stopPropagation();
	},
	takeMeToItClick: function(e){
		window.location.href =  `#/details?account=${this.props.cloneSuccessPopup.accountSlug}&lib=${encodeURIComponent(this.props.libName)}&val=${this.props.cloneSuccessPopup.newSlug}`
		this.props.cloneSuccess("openDetail");
	},
	render: function(){
		return(
			<div className="modal__mask"  onClick = {this.handleCloseClick}> 
				<div className="modal__content modal--md" onClick = {this.stopPropogation}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">Success</h3>
				    <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCloseClick}>
				    	<i className="fa fa-close"> </i>
				    </a> 
				  </div>
				  <div className="modal__body clearfix">
				    <div className="form__row clearfix">
				      <p>Congratulations! You have successfully cloned <strong>"{this.props.themeName}"</strong>. It has been added to your Design Library.</p>
				    </div>
				    <div className="buttons clearfix">
				      <button className="btn__lg bg-bright" onClick = {this.handleCloseClick}>Ok</button>
				      <button className="btn__lg bg-dark" onClick = {this.takeMeToItClick}>Take Me To It</button>
				    </div>
				  </div>
				</div>
			</div>
		);
	}
});

export {CloneSuccessPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/CloneSuccessPopup.jsx
 **/